import { render, staticRenderFns } from "./PageNoData.vue?vue&type=template&id=0b44df54&"
import script from "./PageNoData.vue?vue&type=script&lang=js&"
export * from "./PageNoData.vue?vue&type=script&lang=js&"
import style0 from "./PageNoData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports